import { Badge } from "../ui/Badge";

type ParticipantStatus = "PENDING" | "APPROVED" | "REJECTED" | "CANCELLED";

function getVariant(
  status: ParticipantStatus,
): "warning" | "success" | "error" | "info" {
  switch (status) {
    case "PENDING":
      return "warning";
    case "APPROVED":
      return "success";
    case "REJECTED":
      return "error";
    case "CANCELLED":
      return "info";
  }
}

export function ParticipantStatusBadge({
  status,
}: {
  status: ParticipantStatus;
}) {
  return (
    <Badge variant={getVariant(status)} size="sm">
      {status}
    </Badge>
  );
}
